module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete"
  }, [(_vm.passwordProtect) ? _c('div', {
    staticClass: "signup__container"
  }, [_c('InputField', {
    attrs: {
      "title": "Hello",
      "type": "text",
      "placeholder": "football",
      "autocomplete": "none",
      "autocapitalize": "off",
      "disabled": false,
      "errored": false,
      "errorMessage": ""
    },
    model: {
      value: (_vm.pword),
      callback: function($$v) {
        _vm.pword = $$v
      },
      expression: "pword"
    }
  })], 1) : _c('div', [(_vm.preloaderShow) ? _c('Preloader') : _vm._e(), _vm._v(" "), (_vm.errorPopup) ? _c('ErrorModal', {
    attrs: {
      "title": "Error",
      "message": "An error occurred."
    },
    on: {
      "dismissError": _vm.dismissError
    }
  }) : _c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Delete Ohana User")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle--delete"
  }, [_c('p', [_vm._v("This will delete the user and all data associated with the user (contacts, messages, photos, Twilio Phone Number)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('InputField', {
    attrs: {
      "title": "UID",
      "type": "text",
      "placeholder": "abcd1234",
      "autocomplete": "text",
      "autocapitalize": "off",
      "disabled": _vm.inputDisabled,
      "errored": _vm.uidFound,
      "errorMessage": _vm.errorMessage
    },
    model: {
      value: (_vm.uid),
      callback: function($$v) {
        _vm.uid = $$v
      },
      expression: "uid"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.userGetter) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundSubscriptionStatus),
      expression: "foundSubscriptionStatus"
    }],
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5em",
      "color": "red",
      "font-weight": "700"
    }
  }, [_vm._v("THIS USER IS A SUBSCRIBER")]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundName),
      expression: "foundName"
    }]
  }, [_vm._v("Name:      " + _vm._s(_vm.foundName) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundEmail),
      expression: "foundEmail"
    }]
  }, [_vm._v("Email:       " + _vm._s(_vm.foundEmail) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundNumber),
      expression: "foundNumber"
    }]
  }, [_vm._v("Phone:     " + _vm._s(_vm.foundNumber) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundContactsCount),
      expression: "foundContactsCount"
    }]
  }, [_vm._v("Contacts:     " + _vm._s(_vm.foundContactsCount) + " ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foundMessagesCount),
      expression: "foundMessagesCount"
    }]
  }, [_vm._v("Messages:     " + _vm._s(_vm.foundMessagesCount) + " ")])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    class: {
      'button--disable': !this.uidFound || this.buttonDisabled,
        'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteUser($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Delete Account")]), _vm._v(" "), _c('span', {
    staticClass: "button__subtitle"
  }, [_vm._v("This is PERMANENT")])])]), _vm._v(" "), (!_vm.resetButtonDisabled) ? _c('div', {
    staticClass: "step__button--reset"
  }, [_c('a', {
    class: {
      'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetClicked($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Reset")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.logEntries.length) ? _c('div', {
    staticClass: "log"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Log")]), _vm._v(" "), _c('ul', _vm._l((_vm.logEntries), function(entry) {
    return _c('li', {
      style: ({
        color: entry.color
      })
    }, [_vm._v(" " + _vm._s(entry.message) + " ")])
  }), 0)]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27786366","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-pages/Delete.vue
// module id = 534
// module chunks = 1